import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'input'
  ]

  connect() {
    // console.log('countable')
  }

  increment(){
    this.inputTarget.value = Number(this.inputTarget.value) + 1
  }

  decrement(){
    if(this.inputTarget.value > 0){ 
      this.inputTarget.value = Number(this.inputTarget.value) - 1
     }
  }
}